import { render, staticRenderFns } from "./McMenuItem.vue?vue&type=template&id=c21993c4"
import script from "./McMenuItem.vue?vue&type=script&lang=js"
export * from "./McMenuItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports